module.exports = __webpack_public_path__ + "img/articulos4.6c37d0e4.png";